import { createReducer } from '@reduxjs/toolkit';
import { unsetEmpresaAction, setEmpresaAction } from './empresaActions';
import { EmpresaState } from './empresaTypes';

export const initialState: EmpresaState = null;

const empresaReducer = createReducer(initialState, {
  [setEmpresaAction.toString()]: (state, action) => {
    return action.payload;
  },
  [unsetEmpresaAction.toString()]: (state, action) => {
    return null;
  }
});

export default empresaReducer;
